import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';

export interface UserProfileState {
  userProfile: {
    id: string;
    fullName: string;
    email: string;
    imageURL?: string;
  };
  token: string;
  graphToken: string;
  isAuthenticated: boolean;
  isLoading: boolean;
  errorMessage: string;
}

const initialState: UserProfileState = {
  userProfile: {
    id: '',
    fullName: '',
    email: '',
    imageURL: ''
  },
  token: '',
  graphToken: '',
  isAuthenticated: false,
  isLoading: false,
  errorMessage: ''
};

export const UserProfileStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(({ userProfile }) => ({
    profile: computed(() => userProfile() || initialState.userProfile)
  })),
  withMethods((store) => ({
    StartLoading: () => {
      patchState(store, { isLoading: true, errorMessage: '' });
    },
    EndLoading: () => {
      patchState(store, { isLoading: false });
    },
    EndLoadingWithError: (error: string) => {
      patchState(store, { isLoading: false, errorMessage: error });
    },
    Authenticate: (isAuthenticated: boolean) => {
      patchState(store, { isAuthenticated });
    },
    SetUserProfile: (userProfile: { id: string; fullName: string; email: string; imageURL?: string }) => {
      patchState(store, { userProfile: { ...store.userProfile(), ...userProfile } });
      try {
        if (userProfile?.email) {
          localStorage.setItem('email', userProfile.email);
        } else {
          localStorage.removeItem('email');
        }
      } catch {}
    },
    CleanUserProfile: () => {
      patchState(store, {
        userProfile: { id: '', fullName: '', email: '', imageURL: '' }
      });
      try { localStorage.removeItem('email'); } catch {}
    },
    SetToken: (token: string) => {
      patchState(store, { token });
    },
    SetGraphToken: (graphToken: string) => {
      patchState(store, { graphToken });
    },
    SetUserImage: (imageURL: string) => {
      patchState(store, {
        userProfile: { ...store.userProfile(), imageURL: imageURL || '' }
      });
    }
  }))
);